import React, { Component } from "react";

class ReturnUpSVG extends React.Component {
  render() {
    return (
      <svg
        className={"svg-container " + this.props.svgClassName}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 16 16"
      >
        <path
          className="svg"
          d="M11.1,11.3c0,2.6-1.7,4.7-3.8,4.7l0,0h0c0,0,0,0,0,0v0l-6.7,0C0.3,16,0,15.7,0,15.4s0.3-0.6,0.6-0.6h6.7v0
	c1.5,0,2.7-1.6,2.7-3.6c0-2-1.2-3.6-2.7-3.6v0H1.9l2.7,2.8c0.2,0.2,0.2,0.6,0,0.8c-0.1,0.1-0.3,0.2-0.4,0.2c-0.2,0-0.3-0.1-0.4-0.2
	L0.2,7.5C0.1,7.4,0,7.3,0,7.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0-0.1c0-0.1,0-0.1,0-0.2c0,0,0,0,0,0
	c0,0,0,0,0,0c0,0,0,0,0,0c0-0.1,0.1-0.1,0.1-0.1l3.6-3.8c0.2-0.2,0.6-0.2,0.8,0c0.2,0.2,0.2,0.6,0,0.8L1.9,6.6h5.4v0
	C9.4,6.6,11.1,8.7,11.1,11.3z M15.2,0H0.8C0.4,0,0,0.4,0,0.8V3c0,0.3,0.3,0.6,0.6,0.6S1.1,3.4,1.1,3V1.1h13.7v13.7h-3.2
	c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6h3.5c0.4,0,0.8-0.4,0.8-0.8V0.8C16,0.4,15.6,0,15.2,0z M7.8,3.8c0.4,0,0.8-0.4,0.8-0.8
	S8.3,2.2,7.8,2.2S7,2.6,7,3S7.4,3.8,7.8,3.8z M11.3,3c0-0.4-0.4-0.8-0.8-0.8S9.7,2.6,9.7,3s0.4,0.8,0.8,0.8S11.3,3.4,11.3,3z
	 M13.7,3c0-0.4-0.4-0.8-0.8-0.8S12.1,2.6,12.1,3s0.4,0.8,0.8,0.8S13.7,3.4,13.7,3z"
        />
      </svg>
    );
  }
}

export default ReturnUpSVG;



// WEBPACK FOOTER //
// ./src/svg/ReturnUpSVG.jsx